export default __webpack_public_path__ + "static/media/map.2ba8a26a.jpg";